import { stringifyEntityRef } from "@backstage/catalog-model";
import { InfoCard } from "@backstage/core-components";
import { useApi, identityApiRef } from "@backstage/core-plugin-api";
import { useEntity } from "@backstage/plugin-catalog-react";
import { Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";

/**
 * Card que permite crear un pull request para cambiar el sistema
 * asociado al componente actual.
 */
export const EntityUpdateSystemCard = () => {
  const { entity } = useEntity();
  const navigate = useNavigate();
  const identityApi = useApi(identityApiRef);

  // Template namespace and name
  const templateNamespace = "default";
  const templateName = "update-component-system";

  // Extract current system from entity
  const rawSystem = entity.spec?.system;
  const currentSystem = typeof rawSystem === "string" ? rawSystem : undefined;

  const handleLaunchTemplate = async () => {
    const profileInfo = await identityApi.getProfileInfo();
    const entityRef = stringifyEntityRef(entity);

    const formData = {
      componentRef: entityRef,
      userName: profileInfo.displayName || undefined,
      userEmail: profileInfo.email || undefined,
    };

    const queryParams = new URLSearchParams({
      formData: JSON.stringify(formData),
    });
    navigate(
      `/create/templates/${templateNamespace}/${templateName}?${queryParams}`,
    );
  };

  return (
    <InfoCard title="Cambiar Sistema" variant="gridItem">
      <div style={{ padding: "16px" }}>
        {currentSystem && (
          <p style={{ marginBottom: "8px" }}>
            <strong>Sistema actual:</strong> {currentSystem}
          </p>
        )}
        <p style={{ marginBottom: "16px" }}>
          Crea un pull request para cambiar el sistema asociado a este
          componente.
        </p>
        <Button
          variant="contained"
          color="primary"
          onClick={handleLaunchTemplate}
        >
          Cambiar sistema
        </Button>
      </div>
    </InfoCard>
  );
};
